import {
  SHOW_MODAL_REGISTRATION_BUSINESS,
  SHOW_OTP_REGISTRATION_BUSINESS,
  RESET_CAPTCHA_REGISTRATION,
  SET_OTP_REQUEST_ID,
  VERIFY_OTP,
  SET_USER_FORM,
  OTP_ERROR,
} from './types';

export function setOtpRequestId(requestId) {
  return { type: SET_OTP_REQUEST_ID, payload: { request_id: requestId } };
}

export function setUserForm(userForm) {
  return { type: SET_USER_FORM, payload: { userForm } };
}

export function setModalRegistration(params, formValue) {
  return {
    type: SHOW_MODAL_REGISTRATION_BUSINESS,
    payload: { showModalRegistration: params, registrationForm: formValue },
  };
}

export function setOtpRegistration(params) {
  return {
    type: SHOW_OTP_REGISTRATION_BUSINESS,
    payload: { showOtpRegistration: params },
  };
}

export function verifyOtp(data) {
  return { type: VERIFY_OTP, payload: { data } };
}

export function resetCaptcha(params) {
  return {
    type: RESET_CAPTCHA_REGISTRATION,
    payload: { resetCaptcha: params },
  };
}

export function otpError(params) {
  return { type: OTP_ERROR, payload: { otpError: params } };
}
